import { css, cx } from '@linaria/core'
import type { HTMLProps } from 'react'
import { fragments, style } from '#styles'

const spinnerClass = css`
  display: flex;
  flex-direction: column;
  align-items: center;

  align-self: center;
  margin-top: auto;
  margin-bottom: auto;
  margin-left: auto;
  margin-right: auto;

  &[data-size='xxs'] {
    display: inline-flex;
  }

  &[data-size='m'] {
    ${fragments.textStyle.body.s.regular}
    gap: 12px;
  }

  &[data-size='l'] {
    ${fragments.textStyle.body.m.regular}
    gap: 16px;
  }

  &[data-size='xl'] {
    ${fragments.textStyle.body.l.regular}
    gap: 32px;
  }
  
  &.direction-row {
    flex-direction: row;
    align-items: center;
    
    gap: 8px;
  }

  > .spinner {
    &[data-size='xxs'] {
      width: 12px;
      height: 12px;
    }

    &[data-size='xs'] {
      width: 16px;
      height: 16px;
    }

    &[data-size='s'] {
      width: 20px;
      height: 20px;
    }

    &[data-size='m'] {
      width: 24px;
      height: 24px;
    }

    &[data-size='l'] {
      width: 48px;
      height: 48px;
    }

    &[data-size='xl'] {
      width: 96px;
      height: 96px;
    }

    > svg {
      height: 100%;
      width: 100%;
      display: block;
      animation: 1000ms cubic-bezier(0.4, 0.15, 0.6, 0.85) 0s infinite normal none running spinning;
      fill: none;

      > ._trail {
        stroke-linecap: round;
        transform-origin: center center 0px;
        stroke: ${style.themeColors.textDefault};
        stroke-dasharray: 40px, 220px;
        stroke-dashoffset: 0px;
        stroke-width: 5px;
      }

      > ._track {
        stroke: ${style.themeColors.backgroundBoxed};
        stroke-width: 5px;
      }

      @keyframes spinning {
        0% {
          transform: rotate(0deg);
        }
        100% {
          transform: rotate(360deg);
        }
      }
    }
  }
`

export const Spinner = ({
  className,
  size,
  subtitle,
  ...props
}: {
  size?: 'xl' | 'l' | 'm' | 's' | 'xs' | 'xxs'
  subtitle?: string
} & Omit<HTMLProps<HTMLDivElement>, 'size'>) => {
  return (
    <div className={cx(className, spinnerClass)} data-size={size ?? 'l'} {...props}>
      <div className="spinner" data-size={size ?? 'l'}>
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48">
          <circle className="_track" cx="24" cy="24" r="21.5" />
          <circle className="_trail" cx="24" cy="24" r="21.5" />
        </svg>
      </div>
      {subtitle}
    </div>
  )
}
